var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon--question",on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":require("@/render/assets/images/home/icon_question.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }